export const emptyObject = Object.freeze(Object.seal({}))
